import { useEffect } from 'react'

import { NextSeo } from 'next-seo'

import { Register } from '~/components/auth/register'
import { SignIn } from '~/components/auth/signin'
import { Layout } from '~/components/common'
import { useAuthV2 } from '~/hooksV2'

const Account = () => {
  const { user, loading, called, isAuthenticated } = useAuthV2()
  useEffect(() => {
    if (user && !loading && called && isAuthenticated) window.location.replace('/account/dashboard')
  }, [called, isAuthenticated, loading, user])
  return (
    <>
      <NextSeo
        title="Account | Tucker Tub"
        description="Tucker Tub Account"
        openGraph={{
          title: 'Account | Tucker Tub',
          description: 'Tucker Tub Account',
          url: process.env.NEXT_PUBLIC_FRONTEND_URL,
          type: 'website',
          locale: 'en_AU',
          site_name: 'Tucker Tub'
        }}
      />
      <Layout isPageShow={true} >
        <div className="min-h-inherit bg-colorFifteen">
          <section className="container grid min-h-inherit grid-cols-1 space-x-0 py-20  sm:grid-cols-2 sm:space-x-20">
            <SignIn />
            <Register />
          </section>
        </div>
      </Layout>
    </>
  )
}

export default Account
